jQuery( function($) {

    $('.js-filtros').each(function (i, el) {
        var $el = $(el);
        var $name = $el.find('.js-filtros__name');
        var $btn = $el.find('.js-filtros__btn');

        $btn.on('click', function () {
            var $this = $(this);
            var number = parseInt( $this.data('number') );

            switch (number) {
                case 1:
                    $name.text(number + ' dormitorio');
                    break;
                case 2:
                    $name.text(number + ' dormitorios');
                    break;
                case 3:
                    $name.text(number + ' dormitorios');
            }
        });
    });

});
